import { cva, type VariantProps } from "class-variance-authority";
import type { HTMLAttributes } from "react";
import { cn } from "../../lib/utils.js";

/**
 * Status badge — the product's verification visual language (§6). Always render
 * with an icon + label (never color alone). Colors use the semantic tokens.
 */
const badgeVariants = cva(
  "inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-xs font-medium",
  {
    variants: {
      variant: {
        verified: "bg-[var(--color-success-subtle)] text-[var(--color-success)]",
        external: "bg-[var(--color-info-subtle)] text-[var(--color-info)]",
        claimed: "bg-secondary text-muted-foreground",
        pending: "bg-[var(--color-warning-subtle)] text-[var(--color-warning)]",
        revoked: "bg-destructive/10 text-destructive",
        neutral: "bg-secondary text-secondary-foreground",
      },
    },
    defaultVariants: { variant: "neutral" },
  },
);

export interface BadgeProps
  extends HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof badgeVariants> {}

export function Badge({ className, variant, ...props }: BadgeProps) {
  return <span className={cn(badgeVariants({ variant }), className)} {...props} />;
}

export { badgeVariants };
